import type { TFunction } from 'i18next';
import { ProjectConfigurationParameters } from 'features/configurations';

export const parseProjectConfiguration = (
  projectConfigurationParameters: ProjectConfigurationParameters,
): { [key: string]: string } => {
  const params: { [key: string]: string } = {};
  projectConfigurationParameters.forEach(({ key, value }) => {
    params[key] = value;
  });

  return params;
};

export const getRoomTypeTitle = (roomType: string | undefined, t: TFunction) => {
  return t(`calculator.ui.room-type.${roomType ? roomType.toLowerCase() : 'unknown'}`);
};

export const getArea = (parameters: { [key: string]: string }): string | number => {
  if (parameters.area) {
    return parameters.area;
  } else if (parameters.length && parameters.width) {
    return Number(parameters.length) * Number(parameters.width);
  }

  return '-';
};

export const isPossibleToCalculateProjectArea = (projectConfiguration: ProjectConfigurationParameters) => {
  const parsedProjectConfiguration = parseProjectConfiguration(projectConfiguration);
  const projectConfigurationRoomArea = getArea(parsedProjectConfiguration);

  return projectConfiguration.length > 0 && !isNaN(Number(projectConfigurationRoomArea));
};
